import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from './components/Header';
import SEO from './components/SEO';
import Main from './pages/Main';
import Category from './pages/Category';
import Details from './pages/Details';
import SearchPage from './pages/SearchPage';
import QuickLinksFragment from './components/QuickLinksFragment';
import ScreenSizeInfoProvider from './ScreenSizeInfoProvider';
import ErrorBoundary from '../../lib/ErrorBoundary';

const AppCenter = props => {
  const {
    fptiImpression,
    location: { pathname },
    structuredPSData,
    fptiClick,
    flatPSData,
    dispatch,
    setRPSFavorites,
    toggleToolFavorite,
    RPSFavorites,
    tools,
    clearSearch,
    app,
    toolServFavorites,
    appSearch,
    staticContext
  } = props;

  const { categories = [] } = structuredPSData;

  // the CategoryToolTile is nested several layers deep in a few places
  // group all these props together to make it easier to pass them down
  // as they're only used by CategoryToolTile component
  const toolTileProps = {
    flatPSData,
    dispatch,
    setRPSFavorites,
    toggleToolFavorite,
    RPSFavorites,
    tools,
    app,
    toolServFavorites
  };

  // When route changes, scroll to top and take impression of page.
  useEffect(() => {
    window.scrollTo(0, 0);
    fptiImpression();
  }, [pathname]);

  const [, , categorySlug, detailsSlug] = pathname.split('/');

  const getPage = (categorySlug, detailsSlug) => {
    if (props.appSearch.query) {
      return (
        <SearchPage
          toolTileProps={toolTileProps}
          fptiClick={fptiClick}
          appSearch={appSearch}
          deviceInfo={app?.deviceInfo}
          fptiImpression={props.fptiImpression}
          dispatch={dispatch}
          clearSearch={clearSearch}
        />
      );
    }

    if (detailsSlug) {
      return <Details {...props} />;
    } else if (categorySlug) {
      const category = categories.find(
        ({ content = {} }) => content.location === categorySlug
      );
      return (
        <Category
          category={category}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      );
    }
    return (
      <Main
        structuredPSData={structuredPSData}
        fptiClick={fptiClick}
        fptiImpression={fptiImpression}
        toolTileProps={toolTileProps}
        defaultRecommended={flatPSData.defaultRecommended}
      />
    );
  };
  const {
    structuredPSData: { content: { imageUrl = '' } = {} } = {},
    location = {},
    seo = {}
  } = props;
  let displayName = 'main';
  if (categorySlug) displayName = 'category';
  if (detailsSlug) displayName = 'details';

  return (
    <ErrorBoundary fptiImpression={fptiImpression}>
      <ScreenSizeInfoProvider staticContext={staticContext}>
        <div id="merchanthub-appcenter" className={displayName}>
          <SEO
            mainImageUrl={imageUrl}
            seoData={seo}
            location={location}
            categorySlug={categorySlug}
            detailsSlug={detailsSlug}
            app={app}
          />
          <Header {...props} />
          {/*render in root view on mobile since the footer is sticky to all pages */
          !props.app.deviceInfo.isDesktop && <QuickLinksFragment />}
          {getPage(categorySlug, detailsSlug)}
        </div>
      </ScreenSizeInfoProvider>
    </ErrorBoundary>
  );
};

AppCenter.propTypes = {
  toolServFavorites: PropTypes.array,
  app: PropTypes.object,
  dispatch: PropTypes.func,
  location: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  toggleToolFavorite: PropTypes.func,
  tools: PropTypes.object,
  structuredPSData: PropTypes.object,
  flatPSData: PropTypes.object,
  seo: PropTypes.object,
  setRPSFavorites: PropTypes.func,
  RPSFavorites: PropTypes.object,
  staticContext: PropTypes.object,
  appSearch: PropTypes.shape({
    query: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.string)
  }),
  clearSearch: PropTypes.func.isRequired,
  recommendations: PropTypes.array
};

export default withRouter(AppCenter);
